export function formatNumber(number: number) {
    return Number.isInteger(number) ? number : parseFloat(number.toFixed(2));
  }
  
  export function USFormatePriceWithDecimal(number: number | string) {
    const newNumber = Number(number);
    return newNumber.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  export function USFormatePriceWithoutDecimal(number: number | string) {
    const newNumber = Number(number);
    return newNumber.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  